import { Component, OnInit } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { HttpClient } from '@angular/common/http';
import { CartService } from '../../../../shared/services/cart.service';
import { DataService } from '../../../../shared/data/data.service';

@Component({
    selector: 'app-popular-products',
    templateUrl: './popular-products.component.html',
    styleUrls: ['./popular-products.component.scss']
})
export class PopularProductsComponent implements OnInit {
    // selectedCategory = 'all';
    selectedCategory: string = '';
    singleProductsBox: any = [];
    projectCategories: any[] = [

        {
            id: '',
            name: 'All Projects',
            active: true
        }

    ];

    projects: any[] = [];

    filteredProjects: any[] = [];

    base_url = 'https://thesmilesstore.in/';

    constructor(private http: HttpClient, private cartService: CartService,private data:DataService) { }

    ngOnInit(): void {
        this.getProjectCategories();
    }

    sectionTitle = [
        {
            title: "Our Popular Toys",
            paragraph: "Explore our best-selling toys loved by kids of all ages. From educational games and creative playsets to exciting remote-control cars and adorable soft toys, every product is carefully selected to inspire fun, learning, and imagination while creating joyful playtime memories."
        }
    ]

    productsSlidesOptions: OwlOptions = {
        loop: true,
        nav: false,
        dots: true,
        autoplayHoverPause: true,
        autoplay: true,
        margin: 30,
        navText: [
            "<i class='bx bx-left-arrow-alt'></i>",
            "<i class='bx bx-right-arrow-alt'></i>"
        ],
        responsive: {
            0: {
                items: 1
            },
            576: {
                items: 2
            },
            768: {
                items: 2
            },
            992: {
                items: 3
            },
            1200: {
                items: 3
            }
        }
    }


    getProjectCategories(): void {

        this.http.post<any>(
            this.data.base_url+'category_data/',
            {}
        ).subscribe({

            next: (response) => {

                if (response.status == 1) {

                    const categories = response.data.map((item: any) => {
                        return {
                            id: item.category_id,
                            name: item.category_name,
                            active: false
                        };
                    });

                    this.projectCategories = [
                        { id: '', name: 'All Projects', active: true },
                        ...categories
                    ];

                    // ✅ FIND "Popular" CATEGORY ID FROM API
                    const popularCategory = categories.find(
                        (cat: any) =>
                            cat.name.toLowerCase().trim() === 'popular items'
                    );

                    if (popularCategory) {

                        // 👇 CALL getProjects WITH ID
                        this.getProjects(popularCategory.id);
                    }
                }

            },

            error: (error) => {
                console.log(error);
            }

        });

    }


    getProjects(category?: string): void {

        const payload = category && category !== '' && category !== 'all'
            ? { category: category }
            : {};

        console.log('📤 Sending payload to backend:', payload);

        this.http.post<any>(

            this.data.base_url+'/supplychain/product_data/',
            payload

        ).subscribe({

            next: (response) => {

                console.log('📥 Backend response:', response);


                if (response.status == 1 && response.data) {

                    // const popularProjects = response.data.filter((project: any) =>
                    //     project.category &&
                    //     project.category.toLowerCase().trim() === 'popular'
                    // );
                    const popularProjects = response.data
                    this.singleProductsBox = popularProjects.map((project: any) => {

                        return {
                            mainImg: project.product_image ,

                            title: project.product_name,

                            newPrice: project.product_cost
                                ? `₹${project.product_cost}`
                                : '',

                            oldPrice: '',

                            sale: '',

                            outOfStock: project.stock === 0 ? 'Out of Stock' : '',
                            id: project.id,
                            category: project.category,
                            detailsLink: 'menu/',
                            description: project.product_description,
                            image: project.image && project.image !== ''
                                ? this.base_url + 'media/' + project.image
                                : 'assets/img/bg-1.1.jpg',
                            price: project.price,
                            quantity: 1,
                        };

                    });

                    console.log('✅ Popular products loaded:', this.singleProductsBox);

                } else {
                    this.singleProductsBox = [];
                }
            },

            error: (error) => {

                console.error('❌ Backend error:', error);

                this.projects = [];
                this.filteredProjects = [];

            }

        });

    }

    convertSystems(systems: any): string[] {
        try {
            if (!systems) {
                return [];
            }
            if (Array.isArray(systems)) {
                return systems;
            }
            if (typeof systems === 'string') {
                if (systems.includes('[')) {
                    return JSON.parse(
                        systems.replace(/'/g, '"')
                    );
                }
                return systems.split(',').map(
                    (item: string) => item.trim()
                );
            }
            return [];
        }
        catch (e) {
            console.log(e);
            return [];
        }
    }


    //     addToCart(item: any): void {
    //     console.log("Item",item);

    //     this.cartService.addToCart({
    //         ...item,
    //         quantity: 1
    //     });

    //     console.log('Item added to cart:', item);
    // }

    addToCart(item: any): void {

        this.cartService.addToCart({
            ...item,
            quantity: item.quantity || 1
        });

        item.quantity = 1;
    }

    increaseQuantity(item: any) {

        if (!item.quantity) {
            item.quantity = 1;
        }

        item.quantity++;
    }

    decreaseQuantity(item: any) {

        if (!item.quantity) {
            item.quantity = 1;
        }

        if (item.quantity > 1) {
            item.quantity--;
        }
    }


}
